<template>
  <div class="row">
    <!--  岗位监测列表  -->
    <div class="flex xs12">
      <va-card title="岗位监测列表">
            <va-button-group>
              <va-button disabled flat color="gray">发布状态：</va-button>
              <va-button  flat  :color="computedColor(null)" @click="handleStatusChange(null)">全部</va-button>
              <va-button v-for="status in statusOptions" :key="status.CODE" flat :color="computedColor(status.CODE)" @click="handleStatusChange(status.CODE)">{{ status.TEXT }}</va-button>
            </va-button-group>
        <div class="row align--center mb-1">
          <div class="flex md6 xs12 sm6">
            <va-input class="ma-0" :value="name" placeholder="搜索公司名称" @input="search" removable>
              <va-icon name="fa fa-search" slot="prepend" />
            </va-input>
          </div>
          <div class="flex md3 xs12 sm6">
            <va-button class="mb-2" flat disabled color="danger">总计{{totalCount}}条结果</va-button>
          </div>
          <div class="flex md3 xs12 sm6">
            <div class="d-flex justify--end">
              <va-button color="info" outline small @click="$router.push('saveCareerMonitor')">创建岗位监测</va-button>
            </div>
          </div>
        </div>

        <va-data-table
          :fields="fields"
          :data="careerMonitors"
          :loading="loading"
          :totalPages="totalPages"
          @page-selected="listCareerMonitor"
          api-mode
        >
          <template slot="imgUrl" slot-scope="props">
            <img :src="props.rowData.organization.logo" class="data-table-server-pagination---avatar" alt="avatar">
          </template>

          <template slot="status" slot-scope="props">
            <va-badge :color=computeStatus(props.rowData.status).color>
              {{ computeStatus(props.rowData.status).text }}
            </va-badge>
          </template>
          <template slot="actions" slot-scope="props">
            <va-popover message="编辑" placement="top">
              <va-button flat small color="gray" icon="fa fa-pencil" @click="$router.push(`updateCareerMonitor/${props.rowData.id}`)"/>
            </va-popover>
            <va-popover message="删除" placement="top">
              <va-button flat small color="gray" icon="fa fa-trash"
                @click="deleteModal = true;deleteId=props.rowData.id" />
            </va-popover>
          </template>
        </va-data-table>

        <va-modal
          v-model="deleteModal"
          title="删除岗位监测"
          okText="提交"
          position="center"
          message="请再次确认是否要删除？"
          @ok="confirmDelete"
        />

      </va-card>
    </div>
  </div>
</template>

<script>

import careerMonitorApi from '../../api/careerMonitor'
import { CAREER_MONITOR_STATUS_TYPES, SERVICE_STATUS_TYPES } from '@/utils/constants'
import { dateFormat, formatTime } from '@/utils/common'
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      message: ['Required field'],
      // serviceId: 3,
      careerMonitors: [],
      name: '',
      loading: true,
      pageNumber: 1,
      pageSize: 10,
      totalCount: 0,
      totalPages: 1,
      deleteModal: false,
      deleteId: null,
      status: null,
      isOfficial: false,
      statusOptions: CAREER_MONITOR_STATUS_TYPES,
      careerMonitorTags: [],
      tagId: null,
      tagTypeName: '岗位监测标签',
      permissions: [],
    }
  },
  computed: {
    fields () {
      return [
        {
          name: 'organizationName',
          title: '公司名称',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:status',
          title: '状态',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'createTime',
          title: '创建时间',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'updateTime',
          title: '更新时间',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:actions',
          title: '操作',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
      ]
    },
  },
  created () {
    this.listCareerMonitor()
  },
  methods: {
    formatTime (time) {
      return dateFormat('YYYY-mm-dd HH:MM', new Date(time * 1000))
    },
    listCareerMonitor (pageNumber = this.pageNumber) {
      this.loading = true
      const params = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
        status: this.status,
        name: this.name,
      }
      careerMonitorApi.listCareerMonitor(params).then(response => {
        this.careerMonitors = response.careerMonitors
        this.careerMonitors.forEach(x => {
          x.createTime = formatTime(x.createTime)
          x.updateTime = formatTime(x.updateTime)
        })
        this.totalPages = response.pages.totalPage
        this.totalCount = response.pages.totalCount
        this.pageNumber = pageNumber
        this.loading = false
      }).catch(error => this.showToast(error.msg, {
        duration: 1000,
        icon: 'fa-warning',
        position: 'top-center',
        fullWidth: false,
      }))
    },

    confirmDelete () {
      if (this.deleteId === null) return
      careerMonitorApi.deleteCareerMonitor(this.deleteId).then(response => {
        if (response.success === true) {
          this.listCareerMonitor(1)
        }
      }).catch(error => this.showToast(error.msg, {
        duration: 1000,
        icon: 'fa-warning',
        position: 'top-center',
        fullWidth: false,
      }))
    },
    computeStatus: function (status) {
      const data = {
        color: 'warning',
        text: '暂无更新岗位',
      }
      if (status === 1) {
        data.color = 'info'
        data.text = '成功'
      }
      if (status === 2) {
        data.color = 'danger'
        data.text = '失败'
      }
      return data
    },
    computedColor: function (status) {
      return this.status === status ? 'info' : 'gray'
    },
    handleStatusChange(status) {
      this.status = status
      console.log(status)
      this.listCareerMonitor(1)
    },
    search: debounce(function (name) {
      this.name = name
      this.listCareerMonitor(1)
    }, 400),
  },
}

</script>
<style lang="scss">
.data-table-server-pagination---avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}
</style>
